import React, { FC } from 'react';

import { createPremiumManager } from '../../../../di';
import { sleep } from '../../../../utils';
import SmsConfirmation from '../../../confirmation/SmsConfirmation';
import { ConfirmSmsCodeForm } from '../../utils';
import Modal from '../Modal';
import { ModalProps } from '../Modal/Modal';

interface Props extends ModalProps {
  confirmationUuid: string;
  onSuccess: () => void;
}

const ReferralConfirmationModal: FC<Props> = ({ active, onClose, confirmationUuid, onSuccess }) => {
  const confirmCode = async (smsCode: string): Promise<void> => {
    const manager = await createPremiumManager();
    await manager.confirmCode(confirmationUuid, smsCode);
  };

  const resendCode = async (): Promise<void> => {
    await sleep(3000);
  };

  return (
    <Modal active={active} onClose={onClose}>
      <SmsConfirmation header="Подтверждение реферального кода" onClose={onClose}>
        <ConfirmSmsCodeForm
          sendCallback={confirmCode}
          resendCallback={resendCode}
          successCallback={onSuccess}
          prefix="referral-conf"
        />
      </SmsConfirmation>
    </Modal>
  );
};

export default ReferralConfirmationModal;
